// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1zFER","text":"SelectPayment_text__3ZznW","title":"SelectPayment_title__1rdMn","btn":"SelectPayment_btn__2iYTt"};